<template>
  <div>
    <div class="container mt-5">
      <div id="home" class="section mb-5">
        <div class="container">
          <div>
            <div class="name-section">
              <p class="name">Hello, I'm Azeem</p>
            </div>
            <div class="about-section">
              <p class="about-heading">Playlist Curator &amp; Software Engineer</p>
              <p class="about-text">Asides curating playlists with madjam, <br>I build and develop systems based on business 
              context to drive better customer experience and adoption. </p>
            </div>
          </div>
        </div>     
      </div>
      <div class="mt-5">
        <Contact />
      </div>
    </div>
  </div>
</template>

<script>
import Contact from '../components/Contact.vue'
export default {
  components: { Contact },
  name: 'Home',
}
</script>
<style scoped>
  .name{
      font-family: 'Roboto', sans-serif;
      font-size: 48px;
      font-weight: 400;
      color: #D0D2D0;
  }

  .about-heading{
    font-weight: normal;
    font-size: 20px;
    color: #949495;
  }

  .about-text{
    color:  #949495;
    font-size: 14px;
  }
  .about-section{
    justify-content: center;
    display: flex;
    flex-direction: column;
  }

  @media only screen and (min-width: 768px) {
    .name{
      font-size: 64px;
    }
    .about-heading{
      font-size: 25px;
    }
    .about-text{
      width: 75%;
      font-size: 18px;
    }
  }

</style>




